module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    class: {
      'mobile-bg': _vm.isMobile
    },
    style: (_vm.size),
    on: {
      "touchstart": _vm.onTouchStart,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd
    }
  }, [_c('Settings'), _vm._v(" "), _c('div', {
    staticClass: "rect",
    class: _vm.drop ? 'drop' : ''
  }, [_c('Decorate'), _vm._v(" "), _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('Matrix', {
    attrs: {
      "propMatrix": _vm.matrix,
      "cur": _vm.cur,
      "reset": _vm.reset
    }
  }), _vm._v(" "), _c('Logo', {
    attrs: {
      "cur": !!_vm.cur,
      "reset": _vm.reset
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "state"
  }, [_c('Point', {
    attrs: {
      "cur": !!_vm.cur,
      "max": _vm.max,
      "point": _vm.points
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.pContent)
    }
  }), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.cur ? _vm.clearLines : _vm.startLines
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.level)
    }
  }), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.cur ? _vm.speedRun : _vm.speedStart,
      "length": 1
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.nextText)
    }
  }), _vm._v(" "), _c('Next', {
    attrs: {
      "data": _vm.next
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('Music', {
    attrs: {
      "data": _vm.music
    }
  }), _vm._v(" "), _c('Pause', {
    attrs: {
      "data": _vm.pause
    }
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('svg', {
    staticStyle: {
      "position": "absolute",
      "width": "0",
      "height": "0",
      "overflow": "hidden"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('defs', [_c('filter', {
    attrs: {
      "id": "seal-roughness",
      "x": "-20%",
      "y": "-20%",
      "width": "140%",
      "height": "140%"
    }
  }, [_c('feTurbulence', {
    attrs: {
      "type": "fractalNoise",
      "baseFrequency": "0.05",
      "numOctaves": "2",
      "result": "noise"
    }
  }), _vm._v(" "), _c('feDisplacementMap', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "noise",
      "scale": "2",
      "xChannelSelector": "R",
      "yChannelSelector": "G"
    }
  })], 1)])]), _vm._v(" "), (_vm.isMobile && _vm.controlMode === 'button') ? _c('Keyboard') : _vm._e(), _vm._v(" "), _c('Guide'), _vm._v(" "), _c('Sutra')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-056e9654"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 168
// module chunks = 1